"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaEventoParticipante = exports.yupEventoParticipante = exports.schemaEvento = exports.yupEvento = exports.categoriaEventoSchema = exports.yupCategoriaEvento = void 0;
const yup = __importStar(require("yup"));
exports.yupCategoriaEvento = yup.object({
    descricao: yup.string().nullable().required(),
});
exports.categoriaEventoSchema = exports.yupCategoriaEvento.shape({});
exports.yupEvento = yup.object({
    nome: yup.string().required().label('Nome do evento').max(80, 'Máximo de 80 caracteres.').default(''),
    descricao: yup.string().nullable().notRequired().label('Descrição do evento').default(''),
    dataIni: yup.date().nullable().default(null).min(new Date(1900, 1, 1)).label('Data do evento'),
    dataFim: yup
        .date()
        .nullable()
        .when('dataIni', (dataIni, schema) => {
        if (dataIni) {
            return schema.min(dataIni);
        }
        return schema;
    })
        .nullable()
        .default(null)
        .label('Final do evento'),
    hora: yup.string().max(15, 'No máximo 15 caracteres.').default('').label('Hora do evento.').nullable(),
    duracao: yup.number().nullable().notRequired().default(30).label('Duração em minutos'),
    tipo: yup.string().max(40, 'Máximo de 40 caracteres.').default('').label('Tipo do evento.').nullable(),
    local: yup.string().max(40, 'Máximo de 40 caracteres.').default('').label('local do evento.').nullable(),
    idCategoriaEvento: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .nullable()
        .default(null)
        .label('Categoria Evento'),
    idSolicitante: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .nullable()
        .default(null)
        .label('Solicitante'),
    idResponsavel: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .nullable()
        .default(null)
        .label('Responsável'),
    feito: yup.boolean().notRequired().default(false).label('Finalizado'),
    privado: yup.number().oneOf([0, 1, 2]).nullable().notRequired().default(0).label('Duração em minutos'),
});
exports.schemaEvento = exports.yupEvento.shape({});
exports.yupEventoParticipante = yup.object({
    nome: yup.string().required().label('Nome do convidado').default(''),
    email: yup.string().required().email().label('E-mail do convidado').default(''),
    aceitou: yup.number().oneOf([0, 1, 2]).nullable().required().default(0).label('Aceita participar'),
    idEvento: yup.number().integer().label('Evento'),
    idConvidou: yup.number().integer().label('Convidou'),
    idConvidado: yup.number().integer().label('Convidado'),
});
exports.schemaEventoParticipante = exports.yupEventoParticipante.shape({});
